import { action } from 'typesafe-actions';
import { schoolSelectionActionTypes as act } from './actionTypes';

export function updateSelectedSchool(selectedSchool) {
  return action(act.SELECT_SCHOOL, { selectedSchool });
}

export function resetSchoolSelection() {
  return action(act.RESET_SCHOOL_SELECTION, {});
}
